import { styled } from "goober";

export const ToggleIconContainer = styled("span")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  position: relative;
`;

export const DefaultIcon = styled("span")`
  position: absolute;
  display: flex;
  transition:
    opacity var(--motion-fast) var(--ease-out),
    transform var(--motion-fast) var(--ease-out);
`;

export const HoverIcon = styled("span")`
  position: absolute;
  display: flex;
  opacity: 0;
  transform: rotate(-90deg) scale(0.5);
  transition:
    opacity var(--motion-fast) var(--ease-out),
    transform var(--motion-fast) var(--ease-out);
`;
